const downloadUrlFile = async (url, filename = 'file') => {
  try {
    const response = await fetch(url, { mode: 'cors' });
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('File download failed:', err);
  }
};

export default downloadUrlFile;
